import { FC } from "react";
import { Marker } from "react-map-gl/mapbox";
import { PlacedObject } from "../../types";

interface ObjectMarkersProps {
  placedObjects: PlacedObject[];
  selectedObject: PlacedObject | null;
  isBoundaryMode: boolean;
  onDragEnd: (event: any) => void;
  onSelect: (object: PlacedObject) => void;
}

export const ObjectMarkers: FC<ObjectMarkersProps> = ({
  placedObjects,
  selectedObject,
  isBoundaryMode,
  onDragEnd,
  onSelect,
}) => {
  return (
    <>
      {placedObjects.map((obj) => (
        <Marker
          key={obj.id}
          longitude={obj.coordinates.longitude}
          latitude={obj.coordinates.latitude}
          anchor="bottom"
          draggable={selectedObject?.id === obj.id && !isBoundaryMode}
          onDragEnd={onDragEnd}
          onClick={
            !isBoundaryMode
              ? (e) => {
                  e.originalEvent.stopPropagation();
                  onSelect(obj);
                }
              : undefined // No function for click
          }
        >
          <div
            className={`map-marker ${
              selectedObject?.id === obj.id ? "selected" : ""
            } ${isBoundaryMode ? "boundary-mode-disabled" : ""}`}
          >
            <span
              role="img"
              aria-label={obj.name}
              style={{
                fontSize: "24px",
                opacity: isBoundaryMode ? 0.5 : 1,
                filter: isBoundaryMode ? "grayscale(100%)" : "none",
              }}
            >
              {obj.type === "plant" ? "🌳" : "🏢"}
            </span>
          </div>
        </Marker>
      ))}
    </>
  );
};
